export const createNotificationData = ({
  data,
  departmentsData,
  currentUserData,
  groupingData,
  type,
  subject,
}: any) => {
  const actionText: Record<string, string> = {
    create: "ثبت",
    edit: "ویرایش",
    delete: "حذف",
  };
  return {
    title:
      departmentsData.find((item: any) => item._id === data.department_id)
        ?.name || "نامشخص",
    description: `${subject} ${data.title ?? data.name} توسط ${
      currentUserData.firstname
    } ${currentUserData.lastname} ${actionText[type] || ""} شد `,
    type,
    created_by: currentUserData._id,
    visited: groupingData
      .filter((group: any) => group.department_id.includes(data.department_id))
      .map((it: any) => ({ user_id: it.user_id, show: true })),
  };
};
